import { ImageBackground, Pressable, StyleSheet, View } from "react-native";
import React, { memo, useRef } from "react";
import Svg, { Path } from "react-native-svg";
import { fp, spH, spV, wp } from "utils/normalizeV2";

import ImageView from "../../../src/image";

import ShoppableVideo from "components/Shoppable/ShoppableVideo";
import VText from "components/VText";
import { useGlobalSearchParams } from "expo-router";
import { useSelector } from "react-redux";

const HomeVideos = ({}) => {
    const videos = useSelector((state) => state.HomeReducer.homeVideos) || [];

    const local = useGlobalSearchParams();
    const _shoppableRef = useRef();

    if (videos?.length == 0) {
        return <></>;
    }

    return (
        <View style={styles.container}>
            <View style={styles.storyContainer}>
                {videos &&
                    Array.isArray(videos) &&
                    videos?.slice(0, 3).map((category, index) => (
                        <Pressable
                            key={index}
                            onPress={() => {
                                _shoppableRef?.current?.show(category?.id);
                            }}
                            style={[styles.categoryCard]}
                        >
                            <ImageBackground
                                resizeMode={ImageView.resizeMode.cover}
                                source={{
                                    priority: ImageView.priority.high,
                                    uri: category?.thumbnailUrl || category?.thumbnailWebUrl,
                                }}
                                style={[styles.categoryImage]}
                            ></ImageBackground>
                            <View
                                style={{
                                    position: "absolute",
                                    top: wp(240),
                                    left: wp(180),
                                }}
                            >
                                <Svg
                                    width="80"
                                    height="80"
                                    viewBox="0 0 80 80"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <Path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M0 40C0 17.92 17.92 0 40 0C62.08 0 80 17.92 80 40C80 62.08 62.08 80 40 80C17.92 80 0 62.08 0 40ZM35.3848 24.4069C33.9885 23.4074 32 24.3669 32 26.0062V53.9938C32 55.6331 33.9885 56.5926 35.3848 55.5931L55.1432 41.5993C56.2856 40.7996 56.2856 39.2004 55.1432 38.4007L35.3848 24.4069Z"
                                        fill="white"
                                    />
                                </Svg>
                            </View>
                            <View
                                style={{
                                    paddingTop: spV(20),
                                }}
                            >
                                <VText numberOfLines={2} ellipsizeMode="tail" style={styles.titleText}>
                                    {category?.title}
                                </VText>
                                <VText
                                    numberOfLines={2}
                                    ellipsizeMode="tail"
                                    style={[styles.subTitleText, { paddingTop: spV(8) }]}
                                >
                                    {category?.description}
                                </VText>
                            </View>
                        </Pressable>
                    ))}
            </View>
            <ShoppableVideo gender={local?.gender ?? "female"} source="homepage" ref={_shoppableRef} />
        </View>
    );
};

export default memo(HomeVideos);

const styles = StyleSheet.create({
    container: {
        marginBottom: spV(60),
        backgroundColor: "rgba(240, 240, 240, 1)",
        paddingBottom: spV(40),
    },
    storyContainer: {
        width: "100%",
        flexDirection: "row",
        paddingHorizontal: spH(74),
    },
    navButton: {
        position: "absolute",
        top: "42%",
        borderRadius: 20,
        padding: 10,
    },
    categoryCard: {
        overflow: "hidden",
        marginRight: spH(20),
        marginTop: spV(15),
    },
    categoryImage: {
        width: wp(420),
        height: wp(562),
        resizeMode: "cover",
    },
    titleText: {
        fontFamily: "LibreBodoni",
        fontSize: fp(16),
        fontWeight: "200",
        width: wp(400),
    },
    subTitleText: {
        fontSize: fp(16),
        fontWeight: "350",
        width: wp(400),
    },
});
